/**
 * blood-thinners.ts
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

import { registerPlugins } from '#plugins/index.js'

// Components
import BloodThinnersVue from './views/blood-thinners/blood-thinners.vue'

// Composables
import { createApp } from 'vue'

// Styles
import 'unfonts.css'

import { store } from '#stores/blood_thinners.js'

async function goApp() {
    const app = createApp(BloodThinnersVue)
    registerPlugins(app, 'bloodThinners')
    await store.dbinit()
    app.mount('#app')
}

goApp()
